module.exports = __webpack_public_path__ + "img/TDE_MiniPortal.1ddce737.png";